import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { WhyLHRIdeal } from '../../lp/WhyLHRIdeal';

Builder.registerComponent(WhyLHRIdeal, {
    name: BUILDER_DIVIDER_NAMES.WhyMilanLHRIsIdeal,
});
